import { Injectable } from '@angular/core';
@Injectable()
export class AppServiceBaseCase {
    MsgList: any = [];

    constructor() {
    }

}